import { render } from "./QuotesAdd.vue?vue&type=template&id=cc4ac552"
import script from "./QuotesAdd.vue?vue&type=script&lang=js"
export * from "./QuotesAdd.vue?vue&type=script&lang=js"
script.render = render

export default script